module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"wellcome":"Welcome back!","labelRegister":"Register","labelForgotPassword":"Forgot Password?","errorMsg":"Invalid username or password"},"es":{"wellcome":"Bienvenido","labelRegister":"Registrar","labelForgotPassword":"Olvidé mi contraseña","errorMsg":"Contraseña o nombre de usuario incorrectos"}}')
  delete Component.options._Ctor
}
